export enum Route {
  Home = 'home',
  Survey = 'survey',
  SurveyPreview = 'survey-preview',
}
